export default {
  hero: {
    title: 'Ziņas un Raksti',
    subtitle: 'Jaunākā informācija par Latvijas uzturēšanos, importu-eksportu un Asian Alley',
  },
  featured: 'Izceltais Raksts',
  allArticles: 'Visi Raksti',
  categories: {
    all: 'Visi',
    latvia: 'Latvijas Uzturēšanās',
    export: 'Imports-Eksports',
    asianAlley: 'Asian Alley',
    guide: 'Ceļvedis',
  },
  empty: {
    title: 'Nav atrasts neviens raksts',
    description: 'Mēģiniet izvēlēties citu kategoriju vai atgriezieties vēlāk.',
  },
  readMore: 'Lasīt Vairāk',
  minuteRead: 'minūtes lasīšanai',
  cta: {
    title: 'Nepieciešamas Konsultācijas par Latvijas Uzturēšanos?',
    description: 'Mūsu ekspertu komanda ir gatava atbildēt uz visiem jautājumiem',
    button: 'Reģistrēties Bezmaksas Konsultācijai',
  },
  detail: {
    backToList: 'Atpakaļ uz Sarakstu',
    share: 'Dalīties',
    relatedPosts: 'Saistītie Raksti',
    tableOfContents: 'Saturs',
  },
} as const;